export const businessCurrency = (country?: any, currency?: string) => {
    const language = country === 'New Zealand' ? 'NZD' : '$';
    return language;
};
